import request from '@/utils/request'

// 查询创建优质基地管理列表
export function listCjyzjd(query) {
  return request({
    url: '/web/zlts/cjyzjd/list',
    method: 'get',
    params: query
  })
}

// 查询创建优质基地管理详细
export function getCjyzjd(recid) {
  return request({
    url: '/web/zlts/cjyzjd/' + recid,
    method: 'get'
  })
}

// 查询创建优质基地管理列表(质量品牌服务模块)
export function cjyzjdList(query) {
  return request({
    url: '/web/zlts/cjyzjd/cjyzjdList',
    method: 'get',
    params: query
  })
}